// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  qc: true,
  apiBaseUrl: 'https://g-efcl-api.azurewebsites.net',
  aadConfig: {
    tenant: 'glogistics',
    stsServer: 'https://glogistics.b2clogin.com/glogistics.onmicrosoft.com/oauth2/v2.0/',
    redirect_url: 'https://g-efcl.azurewebsites.net',
    client_id: '80629c6d-1b9b-4e6f-940f-750a9a523043',
    response_type: 'id_token token',
    silent_renew_url: 'http://g-efcl.azurewebsites.net/silent-renew.html',
    scope: 'openid https://glogistics.onmicrosoft.com/efcl/user_impersonation',
    post_logout_redirect_uri: 'https://g-efcl.azurewebsites.net/home',
    post_login_route: '',
    forbidden_route: '',
    unauthorized_route: '/home',
    auto_userinfo: false,
    log_console_warning_active: true,
    max_id_token_iat_offset_allowed_in_seconds: 30,
    password_reset_policy: 'B2C_1_FCL_Password_Reset',
    password_change_policy: 'B2C_1A_PasswordChange',
    signin_signup_policy: 'B2C_1_DefaultSignInUpPolicy',
    sign_up_policy: 'B2C_1_FCL_SignUp'
  },
  stripeConfig: {
    publicKey: 'pk_test_dpn2MtbqTPejgxyYqh489hfw00b7w71h45'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
